// src/App.js
import React, { useEffect } from 'react';
import { BrowserRouter as Router, useNavigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { onEmbedNavigate, isEmbedMode } from './utils/embedAuth';

import TokenStyles from './styles/tokens';
import GlobalFonts from './styles/GlobalFonts';
import GlobalStyle from './styles/GlobalStyles';
import GlobalCarouselStyle from './styles/GlobalCarouselStyle';
import EmbedTheme from './styles/embed-theme';

import MainLayout from './components/MainLayout';
import AppRoutes from './routes/AppRoutes';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Inside the Router: navigate the SPA when the parent frame posts vault:navigate,
// so Tango's nav drives sub-page changes without reloading the iframe (which
// would re-run the auth handshake). Renders nothing.
const EmbedNavListener = () => {
  const navigate = useNavigate();
  useEffect(() => onEmbedNavigate((path) => navigate(path)), [navigate]);
  return null;
};

const App = () => {
  return (
    <AuthProvider>
      <TokenStyles />
      <GlobalStyle />
      <GlobalFonts />
      <GlobalCarouselStyle />
      {isEmbedMode() && <EmbedTheme />}
      <Router>
        {isEmbedMode() && <EmbedNavListener />}
        <MainLayout>
          <ToastContainer position="top-right" autoClose={2500} hideProgressBar />
          <AppRoutes />
        </MainLayout>
      </Router>
    </AuthProvider>
  );
};

export default App;
